import styled from "@emotion/styled";

export const Container = styled.div`
    padding: 128px 32px 96px 32px;
    width: 100%;
    max-width: 1400px;
    box-sizing: border-box;
    margin: 0 auto;
    @media only screen and (max-width: 600px) {
        padding: 16px 0px;
    }
`

export const VideoContainer = styled.div`
    width: 95%;
    position: relative;
    max-width: 935px;
    box-sizing: border-box;
    margin: 0 auto;
    height: 433px;
    margin-top: 14px;
    border-radius: 29px;
    overflow: hidden;
    transform: translateZ(0);
    padding: 40px 50px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    object-fit: cover;
    @media only screen and (max-width: 1400px) {
        margin: 20px auto;
    }
    @media only screen and (max-width: 600px) {
        margin: 20px auto;
        padding: 10px 10px;
        height: 590px;
    }
    @media only screen and (min-width: 1920px) {
        height: 620px;
        min-width: 90%;
    }
`;

export const VideoInnerContainer = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    top: 0;
    left: 0;
    z-index: -1;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    background-color: #000;
    box-shadow: 0px 0px 5px 15px rgba(255, 255, 255, 0.08235294117647059);
`;

export const Video = styled.video`
    min-width: 100%;
    min-height: 100%;
    box-sizing: border-box;
    border-radius: 22px;
    overflow: hidden;
    transform: translateZ(0);
    -webkit-transform: translateZ(0);
    /* background-color: #000; */
    /* @media only screen and (max-width: 800px) {
        min-width: auto;
    } */
`;

export const MainHeading = styled.h1`
    font-size: 38px;
    color: #fff;
    margin-bottom: 8px;
    & > span {
        color: #ddb930;
    }
    @media only screen and (max-width: 600px) {
        font-size: 26px;
    }
`;

export const SubHeading = styled.p`
    font-size: 18px;
    color: #c1c1c1;
    font-weight: 400;
    margin: 0px auto;
    @media only screen and (max-width: 600px) {
        font-size: 13px;
    }
`;

export const TextContentCont = styled.div`
    width: 90%;
    margin: 0 auto;
    padding-bottom: 32px;
    text-align: center;
`;
